import React, { useEffect, useContext } from "react";
import CartCountContext from "../../../context/CartCount/CartCountContext";

export default function WindowPerformer(props) {
  // const { setCartCount } = useContext(CartCountContext);

  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "visible") {
  //       // window.location.reload();
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, [setCartCount]);

  return <>{props.children}</>;
}
